'use client';

import React, {useCallback, useEffect, useRef, useState} from "react";
import VadImage from "vadimages-nextjs-image-optimizer";

interface IAccordionProps {
    children: React.ReactNode;
    labelOpen: string;
    labelClose: string;
    className?: string;
}

const Accordion = ({
    children,
    labelOpen,
    labelClose,
    className,
}: IAccordionProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const toggleAccordion = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    const contentRef = useRef<HTMLDivElement>(null);
    const [accordionHeight, setAccordionHeight] = useState<number>(0);

    useEffect(() => {
        if (contentRef.current) {
            setAccordionHeight(isOpen ? contentRef.current.scrollHeight : 1);
        }
    }, [isOpen]);

    return (<div className={className}>
        <div style={{
            height: `${accordionHeight}px`,
            overflow: 'hidden',
            transition: 'height 0.7s ease',
        }}>
            <div ref={contentRef}>
                {children}
            </div>
        </div>
        <button className='w-full flex items-center justify-center gap-2.5 rounded-[12px] py-2 px-8' onClick={toggleAccordion}>
            <span className='text-xl'>{ isOpen ? labelOpen : labelClose }</span>
            {
                isOpen
                    ? <VadImage src={'images/icons/collapse-icon.png'} alt={'Collapse'} width={25} height={25} />
                    : <VadImage src={'images/icons/expand-icon.png'} alt={'Expand'} width={25} height={25} />
            }
        </button>
    </div>);
}

export default Accordion;
